// extracted by mini-css-extract-plugin
export var container = "_2v-0";
export var icon = "_2v-1";